<template>
  <div class="collect-box">
    <crumb-tit>
      <span slot="breadTit">{{ $t('message["1371"]') }}</span>
      <span slot="secondTit">{{ $t('message["1371"]') }}</span>
    </crumb-tit>
    <main-i />
    <leave-tip-dialog
      ref="leaveTip"
      @leavelHandler="leavelHandler"
    >
      <div slot="tip-slot">
        {{ $t('message["1512"]') }}，<br>
        {{ $t('message["920"]') }}？
      </div>
    </leave-tip-dialog>
  </div>
</template>
<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
import MainI from '@/components/pc/config/referrer/MainLayout'
import LeaveTipDialog from '@/components/pc/LeaveTipDialog'
import { mapState, mapActions, mapMutations } from 'vuex'
import { cloneDeep } from 'lodash'
export default {
  components: {
    MainI,
    CrumbTit,
    LeaveTipDialog
  },
  data () {
    return {
      leave: {},
      status: false,
      count: 0,
      cloneData: []
    }
  },
  computed: {
    ...mapState('config/referrer', ['datas', 'datasReady']),
    baseinfo () {
      return this.$store.state.baseinfo
    }
  },
  watch: {
    datas: {
      handler (val) {
        if (val) {
          this.count++
          if (this.count > 1 && this.$route.name === 'configreferrer') {
            this.removeClick()
            this.addClick()
          }
        }
      },
      deep: true
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.count > 1 && to.name !== 'RoleManagement') {
      if (this.status) {
        next()
        return
      }
      this.$refs.leaveTip.changeLimitDialog(true)
      this.leave = to
      next(false)
    } else {
      this.removeClick()
      next()
    }
  },
  created () {
  },
  mounted () {
    if (this.datasReady) {
      this.cloneData = cloneDeep(this.datas)
    }
  },
  methods: {
    ...mapActions('config/referrer', ['addClick', 'removeClick']),
    ...mapMutations('config/referrer', ['setDatas']),
    leavelHandler (b) {
      const { leave } = this
      if (b) {
        this.status = true
        this.setDatas(this.cloneData)
        this.$router.push({ name: leave.name, query: leave.query, params: leave.params })
      } else {
        this.status = false
      }
      this.$refs.leaveTip.changeLimitDialog(false)
    }
  }
}
</script>
